/** Page ids used with ProfileNavTopBar `currentPage`. */
export const LOADING_PAGE_KEYS = {
  settings: 'loading.page.settings',
  profile: 'loading.page.profile',
  inbox: 'loading.page.inbox',
  friends: 'loading.page.friends',
  users: 'loading.page.users',
  stats: 'loading.page.stats',
  shop: 'loading.page.shop',
  admin: 'loading.page.admin',
};

/** "Ladataan [page] sivua…" / "Loading [page] page…" */
export function loadingPageText(t, page) {
  const pageKey = LOADING_PAGE_KEYS[page];
  if (!pageKey) return t('common.loading');
  const pageName = t(pageKey);
  return `${t('common.loadingVerb')} ${pageName} ${t('common.loadingPageSuffix')}`;
}
